import React from "react";
import clsx from "clsx";
import Switch from "../../Switch/Switch";
import ErrorHelper from "../../Errors/ErrorHelper";

const PropertyDetailsBuilderAPIConnections = (props) => {
  var tabClasses = clsx({
    active: props.active_tab == "external_apis",
    "tab-pane": true,
  });

  return (
    <div className={tabClasses}>
      {ErrorHelper.renderErrors(props.errors, ['name', 'app_domain', 'address_1', 'city', 'postal_code', 'state', 'main_telephone', 'tollfree_telephone', 'mobile_telephone', 'fax_telephone', 'tdd_telephone', 'twilio_number', 'website_url', 'primary_contact_first_name', 'primary_contact_last_name', 'primary_contact_email', 'primary_contact_phone_number'])}
      <div className="row">
        <div className="col-md-4">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>
              {I18n.t("rentals_united")}
              {props.property.ru_id ? `(${props.property.ru_id})` : null}
            </label>
            <Switch
              onChange={props.onFlipSwitch}
              switchId="ru_active"
              name="ru_active"
              value={props.ru_active}
              onText="enabled"
              offText="disabled"
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>
              {I18n.t("rooms_as_ru_properties")}
            </label>
            <span
              className="ss-help help"
              title={I18n.t("rooms_as_ru_properties_helper_text")}
              style={{'paddingLeft': '10px'}}
            ></span>
            <Switch
              onChange={props.onFlipSwitch}
              switchId="rooms_as_ru_properties"
              name="rooms_as_ru_properties"
              value={props.rooms_as_ru_properties}
              onText="enabled"
              offText="disabled"
            />
            <div>
              {`${I18n.t('reservation_auto_assign')}: ${props.auto_assign ? I18n.t('yes') : I18n.t('no')}`}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{"WIHP"}</label>
            <Switch
              onChange={props.onFlipSwitch}
              switchId="wihp_active"
              name="wihp_active"
              value={props.wihp_active}
              onText="enabled"
              offText="disabled"
            />
          </div>
          {props.wihp_active ? (
            <div className="row">
              <div className="col-md-4">
                <div
                  className="form-group"
                  style={{ marginBottom: 0, marginTop: "0.5rem" }}
                >
                  <label>
                    {I18n.t("wihp_id")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("wihp_helper_text")}
                    ></span>
                  </label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="wihp_id"
                    onChange={props.onChange}
                    value={props.wihp_id || ""}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="form-group"
                  style={{ marginBottom: 0, marginTop: "0.5rem" }}
                >
                  <label>
                    {I18n.t("wihp_conversion_id")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("wihp_helper_text")}
                    ></span>
                  </label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="ad_words_conversion_id"
                    onChange={props.onChange}
                    value={props.ad_words_conversion_id || ""}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className="form-group"
                  style={{ marginBottom: 0, marginTop: "0.5rem" }}
                >
                  <label>
                    {I18n.t("wihp_conversion_label")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("wihp_helper_text")}
                    ></span>
                  </label>
                  <input
                    type="text"
                    autoComplete="new-password"
                    className="form-control"
                    name="ad_words_conversion_label"
                    onChange={props.onChange}
                    value={props.ad_words_conversion_label || ""}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailsBuilderAPIConnections;
